import React, { useEffect, useMemo, useState } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { fbmApi } from '../../../../api/fbm';

const DEFAULT_EXCLUDED_NAMES = ['gopuff', 'doordash', 'imperfect'];

const SourceSelector = ({
    value,
    onChange,
    label = 'Source',
    size = 'small',
    variant = 'outlined',
    className,
    includeAll = true,
    allLabel = 'All Sources',
    excludedNames = DEFAULT_EXCLUDED_NAMES,
}) => {
    const [sourceOptions, setSourceOptions] = useState([]);

    const excludedNamesKey = useMemo(() => {
        try {
            return Array.isArray(excludedNames) ? [...excludedNames].sort().join('|') : '';
        } catch (e) {
            return '';
        }
    }, [excludedNames]);

    useEffect(() => {
        let isMounted = true;
        const getSources = async () => {
            const res = await fbmApi.getFBMAccounts();
            if (!isMounted) return;
            if (res.status) {
                const filteredAccounts = res.data.accounts.filter(
                    (account) => !excludedNames.includes(account.fbmAccountName),
                );
                const options = [
                    { fbmAccountName: 'MISFITS_MARKET', companyName: 'Misfits Market' },
                    ...filteredAccounts,
                ];
                setSourceOptions(options);
            }
        };
        getSources();
        return () => {
            isMounted = false;
        };
    }, [excludedNamesKey]);

    const labelId = 'source-select-label';

    return (
        <FormControl variant={variant} size={size} className={className}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select labelId={labelId} id="source-select" value={value} onChange={onChange} label={label}>
                {includeAll && (
                    <MenuItem value="ALL">
                        <em>{allLabel}</em>
                    </MenuItem>
                )}
                {sourceOptions.map((source) => (
                    <MenuItem key={source.fbmAccountName} value={source.fbmAccountName}>
                        {source.companyName}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export { SourceSelector };
